{
  "next": "Nästa",
  "previous": "Föregående"
}
